import { Action, ACTION_TYPE, ERROR_CODE } from '@abiglobalhealth/go-types'

import { actionsRequest } from './utils'

export const setPaymentStarted = async <T extends Action<ACTION_TYPE.SET_PAYMENT_STARTED>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.SET_PAYMENT_STARTED
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}
